import { BffProvincia } from './types';

/**
 * Mapa nombre -> id de provincias. Mismo motivo que `catalogoVehiculos`: los
 * selects viejos guardan el NOMBRE y el BFF pide `provinciaId`.
 */

const CLAVE = 'auto_bff_provincias';

const normalizar = (nombre?: string): string =>
  (nombre || '').trim().toUpperCase();

const leer = (): Record<string, number> => {
  try {
    const crudo = window.sessionStorage.getItem(CLAVE);
    return crudo ? JSON.parse(crudo) : {};
  } catch {
    return {};
  }
};

export const registrarProvincias = (provincias: BffProvincia[]): void => {
  const mapa = leer();
  (provincias || []).forEach((provincia) => {
    mapa[normalizar(provincia.nombre)] = provincia.id;
  });
  try {
    window.sessionStorage.setItem(CLAVE, JSON.stringify(mapa));
  } catch {
    /* noop */
  }
};

export const idDeProvincia = (nombre?: string): number =>
  leer()[normalizar(nombre)] ?? 0;
